import React from 'react';
import ReportSegments from '../../../ReportSegments/ReportSegments';
import ReportByDayComponent from '../../../../utils/ReportByDayComponent/ReportByDayComponent';
import { statisticsByDay } from '../../../../config';

// Filter (segment) rows of the page: the shared ReportSegments with this page's report params and translations
export const StatisticsByDaySegments = (props) => (
    <ReportSegments
        {...props}
        segmentKeys={(statisticsByDay && statisticsByDay.groupParamsSegment) || []}
        reportComponent={ReportByDayComponent}
        translationKey="statisticsByDay"
    />
);

export default StatisticsByDaySegments;
